// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import React from "react";
import i18n from "i18next";
import { ColumnsType } from "antd/lib/table";

import { orderAscend } from "../../../../utils/Constant";
import { NboAction, NboFeature } from "../../../../api/backend-openapi";

export const ProfilesListColumns = (
  features: NboFeature[]
): ColumnsType<{ label: string; color: string }> => [
  {
    title: i18n.t("profile_list.columns.label"),
    key: "label",
    dataIndex: "label",
    ellipsis: false,
    sorter: false,
    defaultSortOrder: orderAscend
  },
  {
    title: i18n.t("profile_list.columns.color"),
    key: "color",
    dataIndex: "color",
    ellipsis: true,
    sorter: false,
    defaultSortOrder: undefined,
    render: color => <span style={{ color }}>{color}</span>
  },
  ...features.map((feature: NboFeature) => ({
    title: feature.toString().startsWith("nbo")
      ? feature.toString().substring(3)
      : feature,
    key: "feature",
    dataIndex: "rights",
    ellipsis: true,
    sorter: false,
    defaultSortOrder: undefined,
    render: (
      rights: {
        [key in keyof typeof NboFeature]: NboAction[];
      }
    ) => (
      <>
        {rights[feature]?.map(
          right =>
            (
              <div>
                {right.toString().startsWith("nbo")
                  ? right.toString().substring(3)
                  : right}
              </div>
            ) || ""
        )}
      </>
    )
  }))
];
